import { render, staticRenderFns } from "./EditCorporateMember.vue?vue&type=template&id=00b95d4a&scoped=true"
import script from "./EditCorporateMember.vue?vue&type=script&lang=js"
export * from "./EditCorporateMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b95d4a",
  null
  
)

export default component.exports